__turbopack_context__.v({
  "active": "dpe-graph-module__0KEPfa__active",
  "etiquette": "dpe-graph-module__0KEPfa__etiquette",
  "info": "dpe-graph-module__0KEPfa__info",
  "item": "dpe-graph-module__0KEPfa__item",
  "label": "dpe-graph-module__0KEPfa__label",
  "list": "dpe-graph-module__0KEPfa__list",
  "title": "dpe-graph-module__0KEPfa__title",
  "wrapper": "dpe-graph-module__0KEPfa__wrapper",
});
